import { put } from "redux-saga/effects";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { camelizeKeys } from "lib/helpers";
import messages from "../messages";

function* getEnterpriseOrg() {
  const { success, data, error } = yield* makeRequest.get("/enterprise");
  if (success && data) {
    yield put(actions.setEnterpriseOrg(camelizeKeys(data.body)));
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_ENTERPRISE_SETTINGS,
    });
  }
  return null;
}

export default getEnterpriseOrg;
